"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelTransformControls = void 0;
const UiElements_1 = require("../../ui/UiElements");
class ModelTransformControls {
    constructor(parentEl) {
        if (!parentEl) {
            throw new Error("Parent element (modelTransform) is undefined");
        }
        const title = this.createTitle();
        this.element = this.createElement();
        const container = new UiElements_1.DivEl().setClass('transformControlsContainer');
        container.addChild(title);
        container.addChild(this.element);
        parentEl.appendChild(container.domEl);
    }
    dispose() {
        delete this.translateBtn;
        delete this.rotateBtn;
        delete this.scaleBtn;
        delete this.spaceBtn;
        delete this.flipYZBtn;
        delete this.element;
    }
    visible(visible) {
        var _a;
        const display = visible ? '' : 'none';
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.setDisplay(display);
    }
    createTitle() {
        return new UiElements_1.DivEl()
            .setClass('module-title')
            .setId('modelTransformTitle')
            .addAttribute('data-i18n-key', 'TRANSFORMATION');
    }
    createElement() {
        this.translateBtn = this.createRadio("translate" /* TRANSLATE */, true);
        this.rotateBtn = this.createRadio("rotate" /* ROTATE */);
        this.scaleBtn = this.createRadio("scale" /* SCALE */);
        this.spaceBtn = new UiElements_1.CheckboxEl(false);
        this.flipYZBtn = new UiElements_1.CheckboxEl(false);
        this.resetBtn = new UiElements_1.ButtonEl().addAttribute('data-i18n-key', 'RESET');
        const translateLabel = this.createLabelElFor(this.translateBtn, 'POSITION', 'position');
        const rotateLabel = this.createLabelElFor(this.rotateBtn, 'ROTATION', 'rotation');
        const scaleLabel = this.createLabelElFor(this.scaleBtn, 'SCALE', 'scale');
        const spaceLabel = this.createLabelElFor(this.spaceBtn, 'TOGGLE_SPACE', 'space');
        const flipYZLabel = this.createLabelElFor(this.flipYZBtn, 'FLIP_YZ', 'flip');
        return new UiElements_1.DivEl()
            .setClass('modelTransformControls controls')
            .addChild(translateLabel)
            .addChild(rotateLabel)
            .addChild(scaleLabel)
            .addChild(spaceLabel)
            .addChild(flipYZLabel)
            .addChild(this.resetBtn);
    }
    createRadio(modelTransformType, checked = false) {
        const radioEl = new UiElements_1.RadioEl('none', 'btnradio').setId(modelTransformType);
        if (checked) {
            radioEl.addAttribute('checked', '');
        }
        //@ts-ignore
        return radioEl;
    }
    createLabelElFor(el, tooltip, icon) {
        return new UiElements_1.LabelEl('')
            .setClass('icon')
            .addChild(el)
            .addAttribute('data-i18n-attr', `data-title=${tooltip}`)
            .addChild(new UiElements_1.IconEl(icon));
    }
}
exports.ModelTransformControls = ModelTransformControls;
